var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{key:_vm.bucket,staticClass:"dropzone",attrs:{"id":_vm.bucket}},[_c('div',{staticStyle:{"display":"none"},attrs:{"id":'dropzone-message-' + _vm.bucket}},[_c('span',{staticClass:"dropzone-title"},[_c('v-btn',{attrs:{"flat":"","icon":""}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fd78391","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploader/MyDropzone.vue
// module id = 769
// module chunks = 1